export default () => {
  const containers = document.querySelectorAll('.js-video-container')
  if (containers.length < 1) return
  ;[...containers].forEach(container => {
    const video = container.querySelector('.js-video')
    const playButton = container.querySelector('.js-video-play')
    const overlay = container.querySelector('.js-video-overlay')
    const image = container.querySelector('.js-video-image')
    const youtube = container.querySelector('.js-youtube-video')

    // Video has buffered enough to play
    if (video) {
      video.addEventListener('canplay', () => {
        if (video.autoplay && !youtube) {
          // Fade out the image if video is autoplay
          image.classList.add('hidden')
        }
      })
    }

    // Play video
    if (playButton) {
      playButton.addEventListener('click', () => {
        if (image !== null) {
          image.classList.add('hidden')
        }

        overlay.classList.add('hidden')
        playButton.classList.add('hidden')

        if (youtube) {
          video.classList.add('active')
        }

        if (video) {
          video.classList.add('active')
          if (video.readyState > 0) {
            //ie11 fix
            video.currentTime = 0
          }
          video.controls = true
          video.muted = false
          video.play()

          // Turn on any subtitles
          for (let i = 0; i < video.textTracks.length; i++) {
            video.textTracks[i].mode = 'showing'
          }
        }
      })
    }
  })
}



// WEBPACK FOOTER //
// ./src/js/modules/Video.js